import { render, staticRenderFns } from "./UserVerification.vue?vue&type=template&id=1817cf34&scoped=true"
import script from "./UserVerification.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserVerification.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./UserVerification.vue?vue&type=style&index=0&id=1817cf34&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1817cf34",
  null
  
)

export default component.exports